import React from 'react';
import UploadView from '../CommonComponent/UploadView';
import CommonDatePicker, {
  currentYear
} from '../CommonComponent/CommonDatePicker';
import UploadImgComponent from '../CommonComponent/UploadImgComponent';
import { checkFileUploadCriteria } from './checkFileUploadCriteria';
import { Formik } from 'formik';
import * as Yup from 'yup';
import get from 'lodash/get';
import Error from '../../Error/error';

const NewDrivingLicense = ({
  touched,
  errors,
  setstepsInfo,
  data,
  handleBlur,
  handleChange,
  setData,
  setFieldValue,
  setFieldTouched,
  setFieldError
}) => {
  const [startDate, setStartDate] = React.useState(null);
  async function onChange(imgUrl, files, index) {
    const isImagePassingCriteria = await checkFileUploadCriteria(files);

    const { imageType, imageSize, imageResolution } = isImagePassingCriteria;

    let validImage = false;

    validImage =
      imageType &&
      !imageType.errors &&
      imageSize &&
      !imageSize.errors &&
      imageResolution &&
      !imageResolution.errors;

    if (validImage) {
      data.drivingLicense.files = files;
      data.drivingLicense.imgUrl[index] = imgUrl;

      setData('drivingLicense', {
        ...data.drivingLicense,
        imgUrl: data.drivingLicense.imgUrl,
        files: data.drivingLicense.files
      });
    } else {
      // alert(JSON.stringify(isImagePassingCriteria, null, 2));
    }
  }
  const { imgUrl } = data.drivingLicense;
  const frontImg = imgUrl[0];
  const backImg = imgUrl[1];

  return (
    <>
      <div className="  w-full px-2 block md:block  bg-white rounded-lg md:mx-auto">
        {/* //adding new here */}
        <div id="driving_L_inputBox" className="mb-10">
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '30% 50%',
              justifyContent: 'flex-start'
            }}
            className="drivingLicense_box mx-auto  grid justify-start items-center justify-end mt-20 "
          >
            <label
              htmlFor="drivingLicense_No"
              className="text-sm text-black-400 mr-5"
              style={{
                justifySelf: 'end'
              }}
            >
              Enter Driving License
            </label>

            <input
              // name="drivingLicense.drivingLicenseNo"

              onBlur={handleBlur}
              onChange={e => {
                setData('drivingLicense.drivingLicenseNo', e.target.value);
                handleChange(e);
              }}
              style={{
                justifySelf: 'start'
              }}
              type="text"
              id="drivingLicenseNo "
              name="drivingLicense.drivingLicenseNo"
              className={
                (errors.drivingLicense?.drivingLicenseNo &&
                touched.drivingLicense?.drivingLicenseNo
                  ? 'border-red-300'
                  : '') +
                ' border border-grey-850 hover:border-teal focus:border-teal focus:outline-none p-2 w-56'
              }
            />
          </div>
          <div className="text-center absolute  mx-auto  ml-60  mb-5 ">
            <Error
              touched={touched.drivingLicense?.drivingLicenseNo || ''}
              message={errors.drivingLicense?.drivingLicenseNo || ''}
            />
          </div>
        </div>

        <div
          className="  mx-auto flex items-center  mb-10 justify-start"
          style={{ display: 'grid', gridTemplateColumns: '30% 50%' }}
        >
          <label
            style={{
              justifySelf: 'center'
            }}
            htmlFor="drivingLicense_DOB"
            className="text-sm text-black-400 "
          >
            Date of Birth
          </label>
          <CommonDatePicker
            onChangeMonth={(value, isValidDate) => {
              setFieldValue('drivingLicense.month', value, true);
              setFieldTouched('drivingLicense.month', true, false);
              if (!isValidDate) {
                setFieldValue(
                  'drivingLicense.date',
                  {
                    value: '',
                    label: 'Date'
                  },
                  true
                );
              }
            }}
            onChangeYear={(value, isValidDate) => {
              setFieldValue('drivingLicense.year', value, true);
              setFieldTouched('drivingLicense.year', true, false);

              if (!isValidDate) {
                setFieldValue(
                  'drivingLicense.date',
                  {
                    value: '',
                    label: 'Date'
                  },
                  true
                );
              }
            }}
            onChangeDate={value => {
              setFieldValue('drivingLicense.date', value, true);
              setFieldTouched('drivingLicense.date', true, false);
            }}
            valueMonth={data.drivingLicense.month}
            valueYear={data.drivingLicense.year}
            valueDate={data.drivingLicense.date}
            errorYear={
              (touched.drivingLicense?.year || null) &&
              get(errors, 'drivingLicense.year.value', false) &&
              (touched.drivingLicense.year === undefined
                ? get(errors, 'drivingLicense.year.value', true)
                : null)
            }
            touchedYear={touched.drivingLicense?.year || false}
            onBlurYear={() => {
              setFieldTouched('drivingLicense.year', true, true);
            }}
            errorMonth={
              touched.drivingLicense?.month &&
              get(errors, 'drivingLicense.month.value', false)
            }
            touchedMonth={touched.drivingLicense?.month}
            onBlurMonth={() => {
              setFieldTouched('drivingLicense.month', true, true);
            }}
            errorDate={
              touched.drivingLicense?.date &&
              get(errors, 'drivingLicense.date.value', false)
            }
            touchedDate={touched.drivingLicense?.date}
            onBlurDate={() => {
              setFieldTouched('drivingLicense.date', true, true);
            }}
            errorMsg={
              (errors.drivingLicense.date &&
                (touched.drivingLicense?.date || '')) ||
              (errors.drivingLicense.month &&
                (touched.drivingLicense?.month || '')) ||
              errors.drivingLicense.year
                ? 'please choose valid dob'
                : null
            }
            type="dob"
          />
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '40% 40%',
            justifyContent: 'center',
            gridColumnGap: '25px'
          }}
        >
          {frontImg && (
            <div>
              <img
                style={{ height: '200px', width: '100%' }}
                src={imgUrl[0]}
                alt=""
              />
              <div style={{ gridColumn: '2' }} className="pt-10">
                <UploadImgComponent
                  onChange={(imgUrl, files) => onChange(imgUrl, files, 0)}
                >
                  <p>Re-upload</p>
                </UploadImgComponent>
                <p>
                  {data.drivingLicense.files[0] &&
                    data.drivingLicense.files[0].name}
                </p>
              </div>
            </div>
          )}
          {!frontImg && (
            <>
              <UploadImgComponent
                onChange={(imgUrl, files) => onChange(imgUrl, files, 0)}
              >
                <UploadView subtext="Upload DL Front" />
              </UploadImgComponent>
            </>
          )}
          {/* -------------- */}

          {/* &&&&&&&&&&& */}
          {backImg && (
            <>
              <img
                style={{ height: '200px', width: '100%' }}
                src={imgUrl[1]}
                alt=""
              />
              <div style={{ gridColumn: '2' }} className="pt-10">
                <UploadImgComponent
                  onChange={(imgUrl, files) => onChange(imgUrl, files, 1)}
                  isChildrenBased
                >
                  <p>Re-upload</p>
                </UploadImgComponent>
                <p>
                  {data.drivingLicense.files[1] &&
                    data.drivingLicense.files[1].name}
                </p>
              </div>
            </>
          )}
          {!backImg && (
            <>
              <UploadImgComponent
                onChange={(imgUrl, files) => onChange(imgUrl, files, 1)}
                isChildrenBased
              >
                <UploadView subtext="Upload DL Back" />
              </UploadImgComponent>
            </>
          )}
        </div>
      </div>
      {/* )}
       </Formik> */}
    </>
  );
};
export default NewDrivingLicense;
